import S from 's-js';
import SArray, { SArray as ArraySignal } from 's-array';

import TZDate from 'lib/TZDate';
import { IAjax } from 'lib/Ajax';
import { tzmoment } from 'lib/tzmoment';

import { Entrypoints } from 'core/app/entrypoints';
import { BerthReservationStatusDisplayName } from 'server/enums/BerthReservation';

import { PCCache } from 'data/PCCache';

import { PortCall } from 'data/models/PortCall';

import { ItineraryPoint } from 'data/models/ItineraryPoint';
import { Port } from 'data/models/Port';
import { Vessel } from 'data/models/Vessel';
import { Issue } from 'data/models/Issue';

import { VesselPortCallRequestOptions } from 'data/models/VesselPortCallRequest';
import { VesselPortCallResponseData } from 'data/models/VesselPortCallResponse';

import { VesselPortCallsCache } from './cache'

import { DateRangeSelector, DateRangeSelectorParams, DateRange } from 'portcall/daterangeselector/model';

export interface VesselPortCallsParams {
    id : number;
    range : DateRange;
    from? : TZDate;
    to? : TZDate;
}

export function VesselPortCalls(
    ajax : IAjax,
    entrypoints : Entrypoints,
    data : PCCache,
    cache : VesselPortCallsCache,
    dateRangeSelectorModel : (params : DateRangeSelectorParams) => DateRangeSelector,
    { id, range, from, to } : VesselPortCallsParams
) {
    let dateRangeSelector = dateRangeSelectorModel({ range, from, to });
    
    const key = () => ({
            VesselId: id,
            FromDate: dateRangeSelector.FromDate().toJSON(),
            ToDate: dateRangeSelector.ToDate().toJSON()
        })

    const model = S(() => cache.VesselPortCallResponses.update1(null, key()));

    S(() =>{
        let req = ajax.Url<VesselPortCallRequestOptions, VesselPortCallResponseData>(entrypoints.VesselPortCalls(key())).Get();
        req.then(json => cache.VesselPortCallResponses.update1(req.Date, json));
    })

    return{
        Model: model,
        DateRangeSelector: dateRangeSelector
    }
}
export type VesselPortCalls = ReturnType<typeof VesselPortCalls>;

export function PortCallsViewModel(
    portcalls : ArraySignal<PortCall>
)
{
    return {
        PortCalls : portcalls.map(portcall => PortCallViewModel(portcall)).sort((p1,p2) => {
            if(p1.MinimumDate() != p2.MinimumDate())
                return +p1.MinimumDate() - +p2.MinimumDate()
            if(p1.PortCall.Port() && p2.PortCall.Port())
                return p1.PortCall.Port()!.Name().toLowerCase() <  p2.PortCall.Port()!.Name().toLowerCase() ? -1 :  p1.PortCall.Port()!.Name().toLowerCase() > p2.PortCall.Port()!.Name().toLowerCase() ? 1 : 0;
            
            return 0;
        })
    }
}
export type PortCallsViewModel = ReturnType<typeof PortCallsViewModel>;

export function PortCallViewModel(
    portcall : PortCall
)
{
    const   LastReservation = S(() => portcall.ActiveReservations().length > 0 ? portcall.ActiveReservations()[portcall.ActiveReservations().length - 1] : null),
            Itineraries = portcall.Itinerary.filter(f => !!f.BerthReservation()).map(i=> ItineraryViewModel(i)),
            MinDate = S(() => portcall.ActiveReservations()[0] && tzmoment(portcall.ActiveReservations()[0].Itinerary()!.Arrival.Effective()).format('MM-DD-YYYY')),
            MinimumDate = S(() => portcall.ActiveReservations()[0] && portcall.ActiveReservations()[0].Itinerary()!.Arrival.Effective()),
            PortName = S(() => portcall.Port() && portcall.Port()!.Name()),
            VoyageNumber = S(() => portcall.VoyageNumber() && portcall.VoyageNumber() != null ? portcall.VoyageNumber() : '');

    return {
        PortCall : portcall,
        Itineraries,
        MinDate,
        LastReservation,
        MinimumDate,
        PortName,
        VoyageNumber,
        NavigateToPortCall: () => window.location.hash = '#!portcallprofile?id=' + portcall.Id()
    }
}
export type PortCallViewModel = ReturnType<typeof PortCallViewModel>;

export function ItineraryViewModel(
    itinerary : ItineraryPoint
){
    
    const berthReservation = itinerary.BerthReservation,
    arrival = tzmoment(itinerary.Arrival.Effective() && itinerary.Arrival.Effective()).format('MM-DD-YYYY [at] HH:mm'),
    departure = tzmoment(itinerary.Departure.Effective() && itinerary.Departure.Effective()).format('MM-DD-YYYY [at] HH:mm'),
    reservationStatus = berthReservation() && berthReservation()!.Status()&& berthReservation()!.Status(),
    LocationName = S(() => itinerary.Location() && itinerary.Location()!.Berth()&& itinerary.Location()!.Name()),
    ReservationStatus = BerthReservationStatusDisplayName[reservationStatus!],
    Issues1 = berthReservation() && berthReservation()!.Issues(),
    Issues = SArray<Issue>([]),
    HasIssues = S(() => Issues().length > 1);
    S(() => {
        if(berthReservation() && berthReservation()!.Issues())
            Issues(berthReservation()!.Issues());
    }
    )
    return {
        Itinerary : itinerary,
        BerthReservation : berthReservation,
        Arrival : arrival,
        Departure : departure,
        LocationName,
        ReservationStatus,
        HasIssues,
        Issues
    }
}
export type ItineraryViewModel = ReturnType<typeof ItineraryViewModel>;


// WEBPACK FOOTER //
// ./apps/portcall/vesselportcalls/model.ts